import { Analytics } from './analytics';
import { AddOnSearchReloadOperation } from '../search';

function initTracking() {
    $('a.result-listing-item').on("click", (e) => {
        let linkText: string | undefined;

        if (e.currentTarget.getElementsByClassName('result-listing-title')[0]) {
            linkText = e.currentTarget.getElementsByClassName('result-listing-title')[0].textContent
        }

        Analytics.sendRawEvent({
            "event": "click_repository",
            "interaction": {
                "click_type": "repository",
                "link_url": e.currentTarget.getAttribute("href"),
                "link_text": linkText
            }
        });
    });
}

initTracking();
AddOnSearchReloadOperation(initTracking);